
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import {
  CardButtons,
  ActionButtonList
} from '@/modules/common/components/cards/CardButtons';

@Component({
  components: { CardButtons }
})
export default class PortfolioTransactionCard extends Vue {
  @Prop({ type: String, required: true })
  public readonly title!: string;

  @Prop({ type: String, required: false, default: '' })
  public readonly description!: string;

  @Prop({ type: String, required: false, default: '' })
  public readonly paragraph!: string;

  button: ActionButtonList[] = [
    { label: 'Ver Agora', action: 'onClick', testId: 'portfolio-card' }
  ];

  @Emit('open')
  open() {}
}
